export class AgeMileageFilter {

  modelCode: string;
  order = 'ASC';
  brand: number;
  page = 0;
  pageSize = 20;
  orderBy = 'CATEGORY';
}
